import React, { useState, useEffect } from 'react';
import Hero from '../Helpers/hero';
import solutionsBanner from '../../assets/images/banners/solutions_banner.png';
import salamanderMegafono from '../../assets/images/logos/megafono.png';
import rocketbg from '../../assets/images/banners/rocket_bg.png';
import rocket from '../../assets/images/banners/rocket.png';

const Solutions = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [startAnimation, setStartAnimation] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            setIsScrolled(scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        
        // Iniciar animación del cohete
        const animationTimer = setTimeout(() => {
            setStartAnimation(true);
        }, 800);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            clearTimeout(animationTimer);
        };
    }, []);

    return (
        <>
        <section className="solutions-hero pt-20 relative overflow-hidden"
        style={{ 
            backgroundImage: `url(${rocketbg})`,
            // backgroundAttachment: 'fixed',
            backgroundPosition: 'center top',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        }}>
            {/* Overlay blanco */}
            <div className="absolute inset-0 bg-white/30 z-0"></div>
            
            {/* Cohete con animación fluida */}
            <img 
                src={rocket} 
                alt="Rocket" 
                className={`absolute ${ startAnimation ? 'rocket-animation' : '' }`}
                style={{
                    left: '20%',
                    top: '120%',
                    height: '50vw',
                    transformOrigin: 'center center',
                    zIndex: 2,
                    opacity: 0
                }}
            />
            
            {/* Llama azul con animación sincronizada */}
            <div 
                className={`absolute ${ startAnimation ? 'flame-animation' : '' }`}
                style={{
                    left: '20%',
                    top: '125%',
                    width: '3vw',
                    height: '8vw',
                    background: 'linear-gradient(to bottom, rgba(0,150,255,0.9), rgba(100,200,255,0.7), rgba(255,255,255,0.5))',
                    borderRadius: '50% 50% 50% 50% / 80% 80% 20% 20%',
                    zIndex: 1,
                    opacity: 0,
                    filter: 'blur(1px)'
                }}
            />
            
            <div className="hero-mkt flex flex-row justify-around items-center p-10 pb-0 contain relative z-10">
                <div className="flex flex-col justify-start items-center gap-4" data-aos="fade-right">
                    <h1 className="text-white font-bold text-center text-8xl">Soluciones <br/> Empresariales</h1>
                    <p className="text-white w-2/3 text-center">Integrando energía, marketing y tecnología para impulsar el crecimiento de tu empresa.</p>
                    <a href='/contact' className='btn btn-primary mt-8'>Solicitar asesoría</a>
                    {/* <img
                        src={solutionsBanner}
                        alt="Equipo trabajando en estrategia digital"
                        className={`mx-auto mt-6 object-cover rounded-lg transition-all duration-700 ${
                            isScrolled ? 'max-w-4xl' : 'max-w-3xl'
                        }`}
                    /> */}
                </div>
            </div>
        </section>
        <section id='marketing-strategic-section' className='bg-white marketing-strategic-section relative overflow-hidden'>
            
            <div className="deco-ball-1"></div>
            
            <div className="contain py-36 relative z-10">                
                <div className="flex flex-col md:flex-row gap-8 mt-8">
                    <div className="w-full md:w-1/2" data-aos="fade-right" data-aos-delay="150">
                        <h2 className="text-gray-700 font-bold text-8xl" data-aos="fade-up">Marketing<br/><span className='text-salient-primary'>Estratégico</span></h2>                        
                        <p className="text-gray-900 mt-4" data-aos="fade-up" data-aos-delay="100">Atrae, cautiva y convierte: tu estrategia digital en manos expertas.</p>

                        <div className='flex flex-col justify-center items-center'>
                            <div className='flex flex-col justify-center items-center gap-6 rounded-xl backdrop-blur-md bg-white/20 border border-white/30 shadow-xl p-6 mt-6 w-full' data-aos="fade-up" data-aos-delay="200">
                                <p className="text-gray-900 font-bold text-2xl">Campañas en:</p>
                                <div className='flex justify-center items-center gap-4'>
                                    <i className="fab fa-facebook-f text-3xl text-blue-600 hover:scale-110 transition-transform duration-200"></i>
                                    <i className="fab fa-instagram text-3xl text-pink-500 hover:scale-110 transition-transform duration-200"></i>
                                    <i className="fab fa-tiktok text-3xl text-black hover:scale-110 transition-transform duration-200"></i>
                                    <i className="fab fa-linkedin-in text-3xl text-blue-700 hover:scale-110 transition-transform duration-200"></i>
                                </div>
                            </div>
                            <div className='flex flex-row justify-center items-center gap-6 w-full'>
                                <div className='flex flex-col justify-center items-center gap-6 rounded-xl backdrop-blur-md bg-white/20 border border-white/30 shadow-xl p-6 mt-6 w-full' data-aos="fade-up" data-aos-delay="200">
                                    <h5 className='font-bold text-2xl'>Automatizacion</h5>
                                    <p>Automatiza tus procesos para optimizar campañas, segmentación y seguimiento de leads, reduciendo costes y aumentando conversiones.</p>                                     
                                </div>
                                <div className='flex flex-col justify-center items-center gap-6 rounded-xl backdrop-blur-md bg-white/20 border border-white/30 shadow-xl p-6 mt-6 w-full' data-aos="fade-up" data-aos-delay="200">
                                    <h5 className='font-bold text-2xl'>Leads</h5>
                                    <p>Genera leads cualificados mediante estrategias multicanal, nutrición y scoring para maximizar conversiones.</p>
                                </div>
                            </div>
                            <a href='/contact' className='btn btn-primary mt-6 w-3/4 rounded-md text-center'>Impulsa tu marca</a>
                        </div>
                    </div>

                    <div className="w-full md:w-1/2 flex flex-col justify-center" data-aos="fade-left" data-aos-delay="200">
                        <img
                            src={salamanderMegafono}
                            alt="Marketing Digital"
                            className="w-full h-auto object-contain"
                        />
                    </div>
                </div>
            </div>
        </section>   
        <section className="bg-salient-primary flex flex-col justify-center items-center p-10" data-aos="zoom-in">
            <h3 className="text-white font-bold mb-4">Atrae, cautiva y convierte: tu estrategia digital en manos expertas</h3>
            <a href='/contact'  className="btn btn-white-outline">Solicitar asesoría</a>
        </section>
        </>
    );
};

export default Solutions;